import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';
import axios from 'axios';
import 'leaflet/dist/leaflet.css';

const API = 'https://app.recensement-enfantsnonproteges.fr';

const DEPT_COORDS = {
  '01':[ 46.2,5.2],'02':[49.5,3.6],'03':[46.3,3.3],'04':[44.1,6.2],'05':[44.6,6.4],
  '06':[43.7,7.2],'07':[44.8,4.6],'08':[49.7,4.7],'09':[42.9,1.6],'10':[48.3,4.1],
  '11':[43.2,2.4],'12':[44.3,2.6],'13':[43.5,5.4],'14':[49.1,-0.4],'15':[45.0,2.6],
  '16':[45.7,0.2],'17':[45.8,-0.7],'18':[47.1,2.4],'19':[45.3,1.9],'21':[47.3,5.0],
  '22':[48.5,-2.8],'23':[46.1,2.0],'24':[45.1,0.7],'25':[47.2,6.3],'26':[44.7,5.2],
  '27':[49.1,1.2],'28':[48.4,1.5],'29':[48.2,-4.0],'30':[44.0,4.2],'31':[43.6,1.4],
  '32':[43.6,0.6],'33':[44.8,-0.6],'34':[43.6,3.8],'35':[48.1,-1.7],'36':[46.8,1.6],
  '37':[47.4,0.7],'38':[45.2,5.7],'39':[46.7,5.6],'40':[43.9,-0.7],'41':[47.6,1.3],
  '42':[45.7,4.2],'43':[45.1,3.9],'44':[47.3,-1.6],'45':[47.9,2.0],'46':[44.6,1.6],
  '47':[44.4,0.5],'48':[44.5,3.5],'49':[47.4,-0.6],'50':[49.1,-1.3],'51':[49.0,4.3],
  '52':[48.1,5.1],'53':[48.1,-0.8],'54':[48.7,6.2],'55':[49.2,5.4],'56':[47.9,-2.8],
  '57':[49.1,6.6],'58':[47.1,3.5],'59':[50.5,3.0],'60':[49.4,2.5],'61':[48.4,0.1],
  '62':[50.5,2.5],'63':[45.8,3.1],'64':[43.3,-0.4],'65':[43.1,0.1],'66':[42.7,2.9],
  '67':[48.6,7.7],'68':[47.8,7.3],'69':[45.8,4.8],'70':[47.6,6.1],'71':[46.6,4.8],
  '72':[48.0,0.2],'73':[45.5,6.4],'74':[46.0,6.5],'75':[48.9,2.3],'76':[49.6,1.1],
  '77':[48.6,3.0],'78':[48.8,1.9],'79':[46.5,-0.5],'80':[50.0,2.3],'81':[43.9,2.1],
  '82':[44.0,1.3],'83':[43.4,6.2],'84':[44.0,5.1],'85':[46.7,-1.4],'86':[46.6,0.4],
  '87':[45.8,1.3],'88':[48.2,6.4],'89':[47.8,3.6],'90':[47.6,6.8],'91':[48.6,2.3],
  '92':[48.8,2.2],'93':[48.9,2.5],'94':[48.8,2.5],'95':[49.1,2.1],
  '971':[16.3,-61.4],'972':[14.7,-61.0],'973':[4.0,-53.0],'974':[-21.1,55.5],'976':[-12.8,45.2]
};

export default function PageCarte() {
  const [depts, setDepts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fiches, setFiches] = useState([]);
  const [selectedDept, setSelectedDept] = useState(null);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/api/stats/departements`),
      axios.get(`${API}/api/fiches`)
    ]).then(([d, f]) => { setDepts(d.data); setFiches(f.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const maxVal = Math.max(...depts.map(d => parseInt(d.total)), 1);

  const getDeptCode = (deptStr) => {
    if (!deptStr) return null;
    return deptStr.split(' ')[0].replace(/^0/, '').padStart(2, '0');
  };

  return (
    <div style={{maxWidth:'1100px',margin:'0 auto',padding:'36px 24px 60px'}}>
      <h2 style={{fontSize:'26px',fontWeight:'800',color:'#0a1f44',textTransform:'uppercase',marginBottom:'4px'}}>Carte</h2>
      <div style={{fontSize:'13px',color:'#888',marginBottom:'20px'}}>Répartition des fiches par département</div>

      {loading ? (
        <div style={{textAlign:'center',padding:'80px',color:'#888'}}>Chargement…</div>
      ) : (
        <>
          <div style={{background:'#fff',borderRadius:'12px',overflow:'hidden',border:'1px solid #dde3f0',marginBottom:'24px'}}>
            <MapContainer center={[46.5, 2.5]} zoom={6} style={{height:'500px'}} scrollWheelZoom={false}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {depts.map(d => {
                const code = getDeptCode(d.departement);
                const coords = DEPT_COORDS[code];
                if (!coords) return null;
                const total = parseInt(d.total);
                const r = 8 + (total / maxVal) * 24;
                return (
                  <CircleMarker key={d.departement} center={coords} radius={r} fillColor={selectedDept===d.departement?'#e24b4a':'#1a7fd4'} color="#0a1f44" weight={1} opacity={0.9} fillOpacity={0.7} eventHandlers={{click: () => setSelectedDept(selectedDept===d.departement?null:d.departement)}}>
                    <Popup><strong>{d.departement}</strong><br/>{total} fiche{total > 1 ? 's' : ''}<br/><span style={{fontSize:'11px',color:'#1a7fd4'}}>Cliquez pour voir les fiches</span></Popup>
                  </CircleMarker>
                );
              })}
            </MapContainer>
          </div>

          {selectedDept && (
            <div style={{background:'#fff',borderRadius:'12px',padding:'20px',border:'2px solid #1a7fd4',marginBottom:'20px'}}>
              <div style={{fontSize:'14px',fontWeight:'700',color:'#0a1f44',marginBottom:'16px'}}>Fiches — {selectedDept}</div>
              {fiches.filter(f => f.departement === selectedDept).length === 0 ? (
                <div style={{color:'#aaa',fontSize:'13px'}}>Aucune fiche publiée pour ce département.</div>
              ) : (
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'12px'}}>
                  {fiches.filter(f => f.departement === selectedDept).map(f => (
                    <div key={f.id} style={{background:'#f4f6fb',borderRadius:'10px',padding:'14px',border:'1px solid #dde3f0'}}>
                      <div style={{fontSize:'12px',fontWeight:'700',color:'#0a1f44',marginBottom:'6px'}}>{f.pp_prenom} {f.pp_nom}</div>
                      <div style={{fontSize:'11px',color:'#888',marginBottom:'8px'}}>{new Date(f.created_at).toLocaleDateString('fr-FR')}</div>
                      {f.type_violences?.length > 0 && <div style={{display:'flex',gap:'4px',flexWrap:'wrap',marginBottom:'6px'}}>{f.type_violences.map(v=><span key={v} style={{fontSize:'9px',padding:'2px 6px',borderRadius:'999px',background:'#1a7fd4',color:'#fff',fontWeight:'700'}}>{v}</span>)}</div>}
                      {f.garde_agresseur && <div style={{fontSize:'11px',color:'#e24b4a',fontWeight:'600'}}>{f.garde_agresseur}</div>}
                      {f.temoignage && <p style={{fontSize:'11px',color:'#555',fontStyle:'italic',marginTop:'6px',lineHeight:'1.5'}}>« {f.temoignage.substring(0,120)}{f.temoignage.length>120?'…':''} »</p>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          <div style={{background:'#fff',borderRadius:'12px',padding:'20px',border:'1px solid #dde3f0'}}>
            <div style={{fontSize:'13px',fontWeight:'700',color:'#0a1f44',marginBottom:'16px',textTransform:'uppercase',letterSpacing:'0.06em'}}>Détail par département</div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:'8px'}}>
              {depts.map(d => (
                <div key={d.departement} style={{background:'#f4f6fb',borderRadius:'8px',padding:'10px',textAlign:'center',border:'1px solid #dde3f0'}}>
                  <div style={{fontSize:'18px',fontWeight:'800',color:'#1a7fd4'}}>{d.total}</div>
                  <div style={{fontSize:'10px',color:'#666',marginTop:'2px',lineHeight:'1.3'}}>{d.departement}</div>
                </div>
              ))}
              {depts.length === 0 && <div style={{gridColumn:'span 5',textAlign:'center',padding:'40px',color:'#aaa'}}>Aucune donnée disponible.</div>}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
